/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import convertOperator from 'cio/utils/operators/convert';
import { allOperators as operators } from 'cio/utils/conditions-operators';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';
import { isBlank } from '@ember/utils';
import { serializeFilter } from 'cio/utils/conditions/serialize/device-attribute';
export default class DeviceAttribute extends BaseEditorComponent {
  // external parameters
  variation = null;
  subLayout = null;
  campaign = null;
  allowComparisonOperator = false;
  allowArrayOperators = false;
  disabled = false;
  condition = null;
  allowBlankName = true;
  onApply() {}

  @computed('condition.{name,value,operator}', 'allowBlankName')
  get errors() {
    let errors = [];

    if (!this.allowBlankName && isBlank(this.condition.name)) {
      errors.push("Device attribute can't be blank.");
    }

    let conditionOperator = convertOperator(this.condition.operator, { to: 'attribute' });
    let operator = operators.findBy('value', conditionOperator);
    if (isBlank(this.condition.value) && operator.allowBlankPredicate === false) {
      errors.push("Value can't be blank.");
    }

    return errors;
  }

  @action
  _onApply() {
    let condition = serializeFilter(this.condition, { useInverse: false });
    condition.operator = convertOperator(condition.operator);
    return this.onApply(condition);
  }
}
